import { PromiseClient } from 'hub-http/adapters/promiseClient';
import http from 'hub-http/clients/apiClient';
import { PaymentLink } from 'payment-link-components/components/PaymentLinkSelect';

const baseUrl = 'sales-checkout/v2/session-templates';
const queryUrl = `${baseUrl}/query`;
const eligibilityUrl = 'payments/v1/payment-accounts/eligibility';

export enum PaymentsEligibilityStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  ACCOUNT_EXISTS = 'ACCOUNT_EXISTS',
}

export enum PaymentsEligibilityUnderwritingStatus {
  IN_KYC = 'IN_KYC',
  IN_UNDERWRITING = 'IN_UNDERWRITING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export type PaymentsEligibilityRequestResponse = {
  status: PaymentsEligibilityStatus;
  underwritingStatus?: PaymentsEligibilityUnderwritingStatus;
  errorCode?: string;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  publishableApiKey?: string;
};

export type Payment = PaymentLink & {
  checkoutUrl: string;
};

export type PaymentsRequestResponse = {
  indexOffset: number;
  limit: number;
  totalCount: number;
  sessionTemplateResponses: Payment[];
};

export const searchLinks = ({
  count,
  offset,
  query,
}: {
  count: number;
  offset: number;
  query: string;
}) => {
  return http
    .get<PaymentsRequestResponse>(queryUrl, {
      query: {
        limit: count,
        indexOffset: offset,
        searchTerm: query,
      },
    })
    .then((response) => {
      const {
        sessionTemplateResponses: results,
        indexOffset,
        totalCount,
      } = response;
      return {
        hasMore: results.length !== totalCount,
        offset: indexOffset || 0,
        count: results.length,
        total: totalCount,
        results,
      };
    });
};

export const eligibility = () => {
  return http.get<PaymentsEligibilityRequestResponse>(eligibilityUrl);
};

export const defaultApiWrapper = (
  apiClient: PromiseClient,
  referrerParam: string
) => ({
  fetchRenderedContent({ id }: { id: number }) {
    return apiClient.get<Payment>(`${baseUrl}/${id}`).then((paymentLink) => {
      const { checkoutUrl, name } = paymentLink;
      return {
        body: name,
        htmlBody: `<a target="_blank" href=${checkoutUrl}?referrer=${referrerParam}>${name}</a>`,
      };
    });
  },
  searchLinks,
  eligibility,
});
